import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import {Button, Row, Col} from 'reactstrap';
import AccountRowComponent from './AccountRowComponent';
import BtnWhiteBlackBorderBigSize from '../Buttons/BtnWhiteBlackBorderBigSize';
import Sticky from 'react-sticky-el';
import {Collapse} from 'reactstrap';
import {changeAccountImage, closeIcon, openIcon} from './icons';
import './selectAccountSticky.scss';

const SelectAccountSticky = (props) => {
  const [overlay, setOverlay] = useState(false);
  const [collapseOpen, setOpen] = useState(false);
  const [fixedPosition, setFixedPosition] = useState(false);
  const selectedItem =
    props.selectBoxObj.length == 1
      ? props.selectBoxObj[0]?.replace(/^(.{3})(.*)$/, '$1-$2')
      : props.selectedItem?.replace(/^(.{3})(.*)$/, '$1-$2');
  let el = document.getElementsByTagName('body')[0];
  const customStyleObject = {
    top: isMobile ? '53px' : '55px',
    boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.2)',
    width: '100%',
  };
  useEffect(() => {
    return () => el.classList.remove('modal-open');
  }, []);

  useEffect(() => {
    if (overlay) {
      el.classList.add('modal-open');
    } else {
      el.classList.remove('modal-open');
    }
  }, [overlay]);

  const collapseAction = () => {
    setOpen(!collapseOpen);
    setOverlay(!overlay);
  };

  const onSelect = (selectedNumber) => {
    props.onSelectChange(selectedNumber);
    collapseAction();
  };

  function getSelectAccountHtml() {
    return (
      <>
        <Row>
          <Col
            xs={12}
            className='mr-auto ml-auto p-0'
            onClick={() => {
              props.selectBoxObj?.length > 1 && collapseAction();
            }}>
            <Row className={`headline-container`}>
              <Col className='text-center'>
                <Row className='small-text d-block'>
                  <p className='mb-0'>מנוי</p>
                </Row>
                <Row className={`bold main-text d-block`}>
                  <p className='mb-0'>
                    {
                      <>
                        <span>{selectedItem || 'בחר מנוי'}</span>
                        {props.selectBoxObj?.length > 1 && (
                          <>
                            {collapseOpen ? (
                              <span className='close-open-icon' dangerouslySetInnerHTML={{__html: closeIcon}}></span>
                            ) : (
                              <span className='close-open-icon' dangerouslySetInnerHTML={{__html: openIcon}}></span>
                            )}
                          </>
                        )}
                      </>
                    }
                  </p>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        {props.showExtraLink && (
          <Row>
            <Col className='extra-link-wrapper'>
              <Button color='link' className='extra-link' onClick={() => props.linkAction()}>
                <svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm0 2.653A1.018 1.018 0 1 1 8 6.69a1.018 1.018 0 0 1 0-2.037zm1.358 6.149c0 .16-.13.291-.292.291H6.934a.292.292 0 0 1-.292-.291v-.574c0-.161.13-.292.292-.292h.291V8.387h-.291a.292.292 0 0 1-.292-.291v-.574c0-.161.13-.292.292-.292h1.544c.161 0 .292.13.292.292V9.94h.291c.161 0 .292.13.292.292l.005.569z'
                    fill='var(--theme-primary, #810ea9)'
                    fillRule='nonzero'
                  />
                </svg>
                <span>{props.extraLinkTitle}</span>
              </Button>
            </Col>
          </Row>
        )}
        <Collapse isOpen={collapseOpen} className='selected-account-list-wrapper'>
          {getCollapseHtml()}
        </Collapse>
      </>
    );
  }

  function getCollapseHtml() {
    if (props.loginData.isOtpAuthenticated) {
      return (
        <div className='change-account-button'>
          <BtnWhiteBlackBorderBigSize svgImage={changeAccountImage} text='שדרוג חבילות למנויים נוספים' onclick={props.redirectToLogin} />
        </div>
      );
    }
    return (
      <Row>
        <Col className='selected-account-list'>
          {props.selectBoxObj.map((account, index) => {
            return <AccountRowComponent key={account} account={account} action={onSelect} />;
          })}
        </Col>
      </Row>
    );
  }

  return (
    <div className='select-account-sticky-component-wrapper'>
      <Sticky
        stickyStyle={customStyleObject}
        stickyClassName={`sticky-thc`}
        onFixedToggle={() => setFixedPosition(!fixedPosition)}
        className='sticky-container'>
        {getSelectAccountHtml()}
      </Sticky>
      {overlay && <div className={`${overlay ? 'overlay fade-in' : ''} ${fixedPosition ? 'sticky' : ''}`}></div>}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loginData: state.authentication.loginData,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SelectAccountSticky);
